export const ITEM_FONTS = {
    normal: {
        fontName: 'h4-regular',
        variantName: 'h4-semibold',
    },
    small: {
        fontName: 'body-regular-black',
        variantName: 'body-semibold-black',
    },
};
export const ITEM_SIZES = {
    normal: 'normal',
    small: 'small',
};
//# sourceMappingURL=constants.js.map